import { AppModule } from '../app.module';
import { Note, NoteArray, NoteTypes } from '../models/domain/note';
import { KeyValuePair, KeyValuePairArray } from '../models/KeyValuePair';
import { Subject } from 'rxjs/Subject';
import { ManagerBase, ManagerModeTypes } from './manager.base';
import { GlobalService } from '../services/global.service';
import { IBaseResponse, BaseResponse } from '../models/comm-http/responses/BaseResponse';
import { NoteHistoryItemArray } from '../models/domain/note.history.item';
import { INoteEditRequest, NoteEditRequest } from '../models/ss-api/requests/note.edit.request';
import { INoteAddRequest, NoteAddRequest } from '../models/ss-api/requests/note.add.request';
import { NoteDetailsDialog } from '../dialogs/note.details/note.details.dialog';
import { Subscription } from 'rxjs';

export class NoteManagerConstructor {

    constructor(noteID: number = 0, memberID: number = 0, hasReviewed: boolean = true) {
        this.NoteID = noteID;
        this.MemberID = memberID;
        this.HasReviewed = hasReviewed;
    }

    NoteID: number = 0
    ShowAfterLoad: boolean = true
    HasReviewed: boolean = false
    NoteType: KeyValuePair<NoteTypes, number> = null
    RelationInfo: string = ''
    RelationObject: any;
    SelectedNoteID: number = 0
    MemberID: number = 0;

    showTemplates: boolean = false;

    IsAddNote: boolean = false;

}

export class NoteManager extends ManagerBase<Note> {

    // public
    public History: NoteHistoryItemArray;

    public showTemplates: boolean = false;

    // private
    private global: GlobalService;
    private notes: NoteArray;
    reviewDisabled: boolean = false;

    // titles
    private titleRegEx = /{relation-info}/gi;

    private titleAddMember: string = 'Create Note for Member {relation-info}.';
    private titleAddLicense: string = 'Create Note for License {relation-info}.';
    private titleAddCredit: string = 'Create Note for Member {relation-info} Credit.';
    private titleAddCreditCard: string = 'Create Note for CreditCard with last four {relation-info}.';
    private titleAddGISCredit: string = 'Create Note for GIS Credit Bundle ID {relation-info}.';
    private titleAddInvoice: string = 'Create Note for Invoice with number {relation-info}.';
    private titleAddTicket: string = 'Create Note for Ticket with number {relation-info}';
    private titleAddAdminLog: string = 'Create Note for AdminLog with subject {relation-info}';
    private titleAddMemberLog: string = 'Create Note for MemberLog with subject {relation-info}';

    private titleEditMember: string = 'Edite Note for Member {relation-info}.';
    private titleEditLicense: string = 'Edit Note for License {relation-info}.';
    private titleEditCredit: string = 'Edit Note for Member {relation-info} Credit.';
    private titleEditCreditCard: string = 'Edit Note for CreditCard with last four {relation-info}.';
    private titleEditGISCredit: string = 'Edit Note for GIS Credit Bundle ID {relation-info}.';
    private titleEditInvoice: string = 'Edit Note for Invoice with number {relation-info}.';
    private titleEditTicket: string = 'Edit note for Ticket with number {relation-info}';
    private titleEditMemberLog: string = 'Edit note for MemberLog with subject {relation-info}';
    private titleEditAdminLog: string = 'Edit note for AdminLog with subject {relation-info}';


    // events
    public OnHistoryLoaded = new Subject<NoteHistoryItemArray>();
    public OnNoteSaved = new Subject<boolean>();

    // subscriptions
    private ManagerActionSubscription: Subscription;

    constructor(data: NoteManagerConstructor) {
        super();

        // services
        this.global = AppModule.injector.get(GlobalService);

        // load
        if (data == null) {
            // just load the manager and do nothing
            this.original = new Note();
            this.newEntity = new Note();
            this.notes = new NoteArray();
            this.SetModetype(ManagerModeTypes.Edit);
            return;
        } else if (data.NoteID != 0) {

            if (data.HasReviewed){
                this.reviewDisabled = true;
            }

            this.SetModetype(ManagerModeTypes.Edit);

            if (data.NoteType != null) {
                // load all notes of this type
                this.LoadType(data.NoteType, data.SelectedNoteID, data.ShowAfterLoad, data.RelationInfo, data.RelationObject);
            } else {

                // load the selected note
                this.Load(data.NoteID, data.ShowAfterLoad, data.RelationObject);
            }

        } else {

            if (data.HasReviewed){
                this.reviewDisabled = true;
            }

            // this is for add mode
            // on add mode we need a note type
            if (data.NoteType == null)
                throw new Error('You need to specify a loadType for Add Mode.'); // no load type found

            this.showTemplates = true;

            this.AddNoteInit(data.ShowAfterLoad, data.NoteType, data.RelationInfo, data.MemberID, data.RelationObject);
        }
    }

    private AddNoteInit(showAfterLoad: boolean, noteType: KeyValuePair<NoteTypes, number>, relationInfo: string, memberID: number, relationObject: any): void {

        // new note
        let newNote = new Note();
        newNote.AdminID = this.global.AdminId;
        newNote.MemberID = memberID;
        newNote.AdminName = this.global.FirstName + ' ' + this.global.LastName;
        newNote.RelationObject = relationObject;
        newNote.NoteTypeList = new KeyValuePairArray<NoteTypes, number>();
        newNote.NoteTypeList.push(noteType);

        // if(!relationInfo) {
        //     relationInfo = relationObject.FirstName + " " + relationObject.LastName;
        // }

        // relation info title
        let title = this.GetAddTitleFromNoteType(noteType.Key);
        title = title.replace(this.titleRegEx, relationInfo);
        newNote.RelationInfo = title;

        // add mode
        super.SetNewEntity(newNote);
        super.SetModetype(ManagerModeTypes.Add);

        // dialog
        if (showAfterLoad)
            this.CloneFixAndLoadDialog();
        else
            this.CloneDateFix();
    }

    public UndoChanges() {
        // because it is possible that we have the active note also in all notes list
        // we will handle this here.

        super.UndoChanges();

        let index = this.notes.findIndex(x => x.ID == this.Note().ID);
        this.notes[index] = this.Note();
    }

    public LoadHistory() {
        super.SetIsBusy(true);

        this.api.getNotesHistory(this.original.ID).subscribe(

            (response: IBaseResponse<NoteHistoryItemArray>) => {
                this.History = response.Data;

                if (response.Result && response.Data != null) {
                    this.OnHistoryLoaded.next(response.Data);
                } else {
                    this.OnHistoryLoaded.next(new NoteHistoryItemArray());
                }

                super.SetIsBusy(false);
            },

            (error: any) => {
                super.SetIsBusy(false);
                this.OnHistoryLoaded.next(new NoteHistoryItemArray());
            }

        );

    }

    private GetAddTitleFromNoteType(noteType: NoteTypes): string {
        switch (noteType) {
            case NoteTypes.Member:
                return this.titleAddMember;

            case NoteTypes.LicenseKey:
                return this.titleAddLicense;

            case NoteTypes.Invoice:
                return this.titleAddInvoice;

            case NoteTypes.CreditCard:
                return this.titleAddCreditCard;

            case NoteTypes.Credit:
                return this.titleAddCredit;

            case NoteTypes.GISCredit:
                return this.titleAddGISCredit;

            case NoteTypes.Ticket:
                return this.titleAddTicket;

            case NoteTypes.AdminLog:
                return this.titleAddAdminLog;

            case NoteTypes.MemberLog:
                return this.titleAddMemberLog;
        }
    }

    private GetEditTitleFromNoteType(noteType: NoteTypes): string {
        switch (noteType) {
            case NoteTypes.Member:
                return this.titleEditMember;

            case NoteTypes.LicenseKey:
                return this.titleEditLicense;

            case NoteTypes.Invoice:
                return this.titleEditInvoice;

            case NoteTypes.CreditCard:
                return this.titleEditCreditCard;

            case NoteTypes.Credit:
                return this.titleEditCredit;

            case NoteTypes.GISCredit:
                return this.titleEditGISCredit;

            case NoteTypes.Ticket:
                return this.titleEditTicket;

            case NoteTypes.AdminLog:
                return this.titleEditAdminLog;

            case NoteTypes.MemberLog:
                return this.titleEditMemberLog;
        }
    }

    public ShowNoteList(): boolean {
        if (this.notes != null && this.notes.length > 0) {
            return true;
        } else {
            return false
        }
    }

    public Note(): Note {
        return this.newEntity;
    }

    public AllNotes(): NoteArray {
        return this.notes;
    }

    public NoteEdited(): boolean {
        return this.original.Note != this.newEntity.Note;
    }

    public StickyEdited(): boolean {
        return this.original.Sticky != this.newEntity.Sticky;
    }

    public SetModetype(mode: ManagerModeTypes): void {
        super.SetModetype(mode);
    }

    public Edited(): boolean {

        if (this.NoteEdited())
            return true;

        if (this.StickyEdited())
            return true;

        // not edited
        return false;

    }

    public SaveChanges(confirm: boolean = true, showResult: boolean = true) {

        if (this.Edited() == false)
            return;

        if (super.ModeType() == ManagerModeTypes.Edit) {
            // edit
            let request = this.GetNoteEditRequest();
            this.SaveAction = this.api.NoteEdit(request);

        } else {
            // add
            let request = this.GetNoteAddRequest();
            this.SaveAction = this.api.NoteAdd(request);

            this.OnNoteSaved.next(true);

        }


        this.SaveChangesBase(confirm, showResult);
    }


    Load(id: number, showAfterLoad: boolean = true, relationObject: any) {

        if (id < 1)
            return;

        this.LoadAction = this.api.getNote(id);

        let DataLoaded = this.OnDataLoaded.subscribe(() => {
            DataLoaded.unsubscribe();

            if (showAfterLoad)
                this.CloneFixAndLoadDialog();
            else
                this.CloneDateFix();

            this.original.RelationObject = relationObject;
            this.newEntity.RelationObject = relationObject;
        })

        this.LoadBase();
    }


    private CloneFixAndLoadDialog() {
        this.CloneDateFix();
    }

    private ShowDialog() {

        this.DialogAction = this.dialogService.addDialog(NoteDetailsDialog, {
            noteManager: this
        });

    }


    LoadType(type: KeyValuePair<NoteTypes, number>, selectedNoteID: number, showAfterLoad: boolean = true, relationInfo: string = '', relationObject: any) {

        this.api.getNotesByType(type.Key, type.Value).subscribe(

            (result: BaseResponse<NoteArray>) => {

                if (result.Data == null || result.Data.length == 0)
                    return;

                this.notes = result.Data;

                // relation info title
                let title = this.GetEditTitleFromNoteType(type.Key);
                title = title.replace(this.titleRegEx, relationInfo);

                // set titles
                this.notes.forEach((note) => { note.RelationInfo = title, note.RelationObject = relationObject })


                // select note
                if (selectedNoteID == 0) {
                    this.SetNewEntity(this.notes[0]);
                } else {
                    this.SelectNoteToEditByID(selectedNoteID);
                }

                if (showAfterLoad) {
                    this.CloneFixAndLoadDialog();
                }

            },

            (error: any) => {
                this.SetIsBusy(false);
            }

        );


    }

    public SelectNoteToEditByID(noteID: number) {
        let index = this.notes.findIndex(x => x.ID == noteID);
        this.SetNewEntity(this.notes[index]);
    }


    private CloneDateFix(): void {

        // dates don't convert to Date so do it manual
        this.original.Created = this.newEntity.Created;
        this.original.Modified = this.newEntity.Modified;
    }


    private GetNoteEditRequest(): INoteEditRequest {

        let request = new NoteEditRequest();

        request.ID = this.newEntity.ID;
        request.AdminID = this.global.AdminId;
        request.Note = this.newEntity.Note;
        request.Sticky = this.newEntity.Sticky;
        request.RequestReview = this.newEntity.RequestReview;

        return request;

    }

    private GetNoteAddRequest(): INoteAddRequest {

        let request = new NoteAddRequest();

        request.AdminID = this.global.AdminId;
        request.Note = this.newEntity.Note;
        request.Sticky = this.newEntity.Sticky;
        request.RequestReview = this.newEntity.RequestReview;
        request.NoteTypeList = this.newEntity.NoteTypeList

        if (this.newEntity.MemberID)
            request.MemberID = this.newEntity.MemberID;
        else
            this.newEntity.MemberID = 0;

        return request;
    }

}
